import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <main className="main" id="top">
      <section
        className="section section--muted section--with-glow section--legal not-found"
        aria-label="Page not found"
      >
        <div className="ambient-glow ambient-glow--hero-1" aria-hidden="true" />
        <div className="container not-found__content">
          <p className="not-found__code" aria-hidden="true">
            404
          </p>
          <h1 className="section__headline">Oops! We can&apos;t find that page</h1>
          <p className="section__intro not-found__intro">
            The page you&apos;re looking for doesn&apos;t exist or may have moved.
          </p>
          <Link className="btn btn--primary" to="/">
            Take Me Home
          </Link>
        </div>
      </section>
    </main>
  );
}
